<template>
  <div id="article-list" v-if="article != null" @click="clickDetails(article.id)">
    <div class="article-pic" ><img :id="article.id" :src="getImageBase64(article.cover, article.id)" alt="标题"></div>
    <div class="article-title"><h3>{{article.title}}</h3></div>
    <div class="article-introduces"><p>{{article.introduction}}</p></div>
    <div v-show="article.showDetails">{{article.content}}</div>
  </div>
</template>

<script>
  import {
    articleList
  } from "./../../api/api"
  import {getLocalStorage, getLocalStorageExpire, setLocalStorage, setLocalStorageExpire} from "../../utils/CommonUtil";

  export default {
    name: "ArticleList",
    props: {
      article: {
        id: null,
        title: "",
        cover: "",
        introduction: "",
        content: ""
      }
    },
    methods: {
      articleList: function (params) {
        const res = articleList(params);
        res.then(x => {
          console.log(x);
          debugger;//目前这个方法没用
          this.$emit("articles", x.data.data);
        })
      },
      clickDetails: function (id) {
        console.log("clickDetails-id:", id);
        this.$router.push({
          name: 'HomeArticleDetails',
          params: {
            //id: id
          },
          query: {
            id: id//页面会有这个值
          }
        })
      },
      getImageBase64: function (imageUrl, id) {
        window.URL = window.URL || window.webkitURL;
        var p = window.location.protocol;
        if(p === "http:"){
          return imageUrl.match("//") ? p + imageUrl : imageUrl;
        }
        imageUrl = p + imageUrl;
        //var imageUrl = 'http://blog-qn.xueyuhuihui.com/ssl.png';
        console.log(p, imageUrl,'-pp');
        let base64 = getLocalStorageExpire(id);
        if (base64 !== null && base64 !== undefined && base64 !== ''){
          return base64;
        }

        var x = new  XMLHttpRequest();
        x.open("get", imageUrl, true);
        x.responseType = "blob";
        x.onload = function(){
          if (this.status === 200){
            var blob = this.response;
            //console.log("blob", blob);
            let fileReader = new FileReader();
            fileReader.onloadend = function (e) {
              base64 = e.target.result;
              setLocalStorageExpire(id, base64);
              //console.log('base64', base64);
              var img = document.getElementById(id);
              img.src = base64;
            };
            fileReader.readAsDataURL(blob);
            /*let src = window.URL.createObjectURL(blob);
            var img = document.getElementById(id);
            img.src = src;
            setLocalStorageExpire(id, src);*/
          }
        };
        x.send();
        //var re = x.response;
        debugger;
        console.log('imageBase64Data', base64);
        console.log('imageBase64Data1', getLocalStorage(id));
        return getLocalStorage(id);
      }
    },
    created() {
      //this.articleList()
      // this.tesUrlPost()
      // this.tesUrlPostBody()
    },
    data: function () {
      return {
        article1: {
          id: null,
          title: "docker--学习一",
          cover: "./../../../static/pic/docker-1.png",
          introduction: "docker的目标提供轻量的建模方式，职责的逻辑分离，快速高效的开发生命周期，鼓励使用面向服务架构",
          content: "docker提供轻量的建模方式：容易上手，用户只需要用几分钟就可以把自己的程序docker化，大多数docker容器只需要不到一秒就可运行起来，由于去除了管理程度的开销，docker容器拥有非常高的性能，同时同一台宿主机中也可运行更多的容器，使用户可以尽可能的充分利用系统资源；\n" +
            "职责的逻辑分离：使用docker开发人员只要关系容器中运行的应用程序，而运维人员只需要关心如何管理容器，docker设计的目的就是要加强开发人员写代码和开发环境与应用程序要部署到开发环境的一致性；\n" +
            "快速高效的开发生命周期：docker的目标之一是缩短代码从开发测试部署上线运行的生命周期，让你们的应用程序具备可移植性；\n" +
            "鼓励使用面向服务的架构：docker推荐使用单个容器只运行一个应用程序或者进程，这样就形成一个分布式的应用模型，在这种模型下应用程序或者服务都可以表现为一系列内部互联的容器，从而使分布式部署应用程序扩展和调试应用程序变得简单，这就像我们在开发中常用的思想，高内聚低耦合单一人任务，这样就能够避免，在同一服务器上部署不同服务时，可能带来的服务之间的互相影响，这样在运行过程中出现问题也比较容易定位问题所在；",
          showDetails: false,
          creatTime: null
        },
        getResponse: {
          status: 200,
          data: {}
        }
      }
    }
  }
</script>

<style scoped>
  div, img, h3, p {
    margin: 0;
    padding: 0;
  }

  #article-list {
    display: inline-block;
    margin: 2px 0;
    width: 100%;
    height: 450px;
    float: left;
    text-align: center;
    border-width: 2px;
    border-style: dotted;
    background: rgba(49, 172, 255, 0.44);
  }

  #article-list .article-pic {
    display: inline-block;
    margin: 2px 0;
    width: 100%;
    min-height: 35%;
    max-height: 35%;
    text-align: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  #article-list .article-title {
    display: inline-block;
    margin: 5px 0;
    width: 100%;
    height: auto;
    max-height: 2em;
    text-align: center;
    overflow: hidden;
  }

  #article-list .article-introduces {
    margin: 5px 0;
    width: 100%;
    height: auto;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;/*子元素垂直排列*/
    -webkit-line-clamp: 7;/*限制两行*/
    word-break: break-all;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #article-list .article-introduces p{
    margin: 5px;
    text-indent: 10%;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/articles/ArticleList.vue